import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "link" ]

  followLink() {
    window.location.hash = this.element.id
    this.linkTarget.click()
  }
}